// extracted by mini-css-extract-plugin
export default {"root":"contact-form_root__woVqX","submitGroup":"contact-form_submitGroup__PHfT4","submitGroupMessage":"contact-form_submitGroupMessage__pqRRb"};